var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    [
      _c(
        "div",
        { staticClass: "q-pa-md row items-start q-gutter-md row" },
        [
          _c(
            "q-card",
            { staticClass: "my-card full-width" },
            [
              _c("div", [
                _c(
                  "h4",
                  { staticClass: "text-h4" },
                  [
                    _c("q-icon", {
                      staticClass: "q-pl-md q-pr-xs",
                      attrs: { name: "far fa-chalkboard-teacher" }
                    }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.live_class.title) +
                        "\n                "
                    )
                  ],
                  1
                )
              ]),
              _c("q-card-separator"),
              _c("q-card-main", { staticClass: "row q-pa-md" }, [
                _c(
                  "div",
                  { staticClass: "text-body1 col-12 q-pl-md q-pb-md" },
                  [_vm._v(_vm._s(_vm.live_class.description))]
                ),
                _c("div", { staticClass: "text-subtitle2 col-12 q-pl-md" }, [
                  _vm._v(_vm._s(_vm.$t("live_class_start_schedule")) + ": "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.fDateTime(_vm.live_class.date_class)) + "H"
                    )
                  ])
                ]),
                _vm.$q.platform.is.mobile
                  ? _c("h5", { staticClass: "text-h5 text-red" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.$t("mobile_live_class_student_helper"))
                        )
                      ])
                    ])
                  : _vm._e()
              ]),
              _c("q-card-separator"),
              _c(
                "q-card-actions",
                { staticClass: "row justify-end q-pa-md" },
                [
                  _c("q-btn", {
                    staticClass: "col-5",
                    attrs: {
                      color: "tertiary",
                      label: _vm.$t("back"),
                      icon: _vm.getIconBtn("back")
                    },
                    on: { click: _vm.closeModal }
                  }),
                  _c("q-btn", {
                    staticClass: "col-5",
                    attrs: {
                      color: "primary",
                      label: _vm.$t("start"),
                      icon: _vm.getIconBtn(_vm.activity)
                    },
                    on: {
                      click: function($event) {
                        _vm.live_class.platform_type === 1
                          ? _vm.gotoClass(_vm.live_class.live_class_id)
                          : _vm.openMeeting(_vm.live_class)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.show_modal_class_room
        ? _c(
            "q-modal",
            {
              attrs: {
                "content-css": { minWidth: "100vw", minHeight: "100vh" },
                "no-backdrop-dismiss": "",
                "no-esc-dismiss": ""
              },
              on: { hide: _vm.hideModalClassRoom },
              model: {
                value: _vm.show_modal_class_room,
                callback: function($$v) {
                  _vm.show_modal_class_room = $$v
                },
                expression: "show_modal_class_room"
              }
            },
            [
              _c(
                "q-modal-layout",
                [
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "fas fa-times"
                        },
                        on: {
                          click: function($event) {
                            return _vm.hideModalClassRoom()
                          }
                        }
                      }),
                      _c("q-toolbar-title", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.live_class.title) +
                            "\n                "
                        )
                      ])
                    ],
                    1
                  ),
                  _vm.show_modal_class_room
                    ? _c("class-room", {
                        attrs: { room: _vm.code_room },
                        on: { hideModalClassRoom: _vm.hideModalClassRoom }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "q-dialog",
        {
          attrs: { "stack-buttons": "", "prevent-close": "" },
          on: {
            cancel: function($event) {
              _vm.show_meet_dialog = false
            },
            hide: function($event) {
              _vm.show_meet_dialog = false
            }
          },
          model: {
            value: _vm.show_meet_dialog,
            callback: function($$v) {
              _vm.show_meet_dialog = $$v
            },
            expression: "show_meet_dialog"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("window_blocked")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("browser_window_blocked_click")) +
                "\n            "
            ),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.live_class.embed,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }
              },
              [_vm._v(_vm._s(_vm.$t("here")))]
            ),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("to_access_the_class")) +
                "\n            "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }